import Spinner from "./Spinner";
import styles from "./PageSpinner.module.css";
export default function PageSpinner() {
    return <Spinner className={styles.spinner} />;
}
